export default "__VITE_ASSET__b1e66bb7__"